export const CONSENT_STORAGE_KEY = 'travelone_widget_consent';
export const CONSENT_POLICY_VERSION = '1.0';
